"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentFavoriteDto = void 0;
class ContentFavoriteDto {
    constructor(contentFavoriteDto) {
        this.id = contentFavoriteDto.id;
        this.userId = contentFavoriteDto.user_id;
        this.contentMetadataId = contentFavoriteDto.content_metadata_id;
        this.lookId = contentFavoriteDto.look_id;
        this.dashboardId = contentFavoriteDto.dashboard_id;
    }
    static get QUERY_FIELDS() {
        return `id,user_id,content_metadata_id,look_id,dashboard_id`;
    }
}
exports.ContentFavoriteDto = ContentFavoriteDto;
